// Clear Button
let clearBtn = document.getElementById('clear-filters-button');
if (clearBtn) {
	clearBtn.addEventListener('click', function(e) {
		almfilters.reset();
	});
}

// Parse current filters
window.almFiltersActive = function(obj) {
	if (clearBtn && clearBtn !== null) {
		if (obj === '') {
			clearBtn.classList.add('inactive');
		} else {
			clearBtn.classList.remove('inactive');
		}
	}
};

// Add filters title
let filters = document.querySelector('.alm-filters');
if (filters) {
	let headerElement = document.createElement('h2');
	headerElement.classList.add('filter-title');
	let title = 'Filter by';
	headerElement.innerHTML = title;
	let search = filters.querySelector('.alm-filter--search, .alm-filter--s');
	if (search) {
		search.appendChild(headerElement);
	}
}
